import payrollTableUngroupedUrl from './payrollTableUngroupedComponent.html';

export default {
  bindings: {
    items: '<',
    schema: '<',
    showDurationsAsDecimals: '<',
    totals: '<',
    columns: '<',
    filtersOpened: '<',
    sortMethod: '=?orderBy',
    getDataForExport: '=?',
    statsOpened: '<',
  },
  controllerAs: 'ctrl',
  controllerProvider: async () =>
    (await import(/* webpackChunkName: "reports" */ './payrollTableUngroupedComponentCtrl'))
      .default,
  templateUrl: payrollTableUngroupedUrl,
};
